import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-graded-score-card',
  templateUrl: './graded-score-card.component.html',
  styleUrls: ['./graded-score-card.component.css']
})
export class GradedScoreCardComponent implements OnInit {

  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
 

  GradedScoreCardModel = {
    StudentID: 0,
    ClassSectionID: "",
    ClassID: 0,
    SectionId: 0,
    ClassName: '',
    PersonalSkillID: 0,
    ExamMapID: 0,
    IsSubmitted:false,
    SectionID:0,
}


GradedScoreCardList = [];



PersonalSkillActivityList = [];
SearchGradedScoreCard  () {
    this.spinnerService.show();
    this.GradedScoreCardList = [];
    this.PersonalSkillActivityList = [];
   
    this.examService.SearchGradedScoreCard(this.GradedScoreCardModel.ClassID, this.GradedScoreCardModel.SectionID, this.GradedScoreCardModel.ExamMapID, this.GradedScoreCardModel.PersonalSkillID).subscribe( (data)=> {
        this.GradedScoreCardList = data.GradedScoreCardList;
        this.PersonalSkillActivityList = data.lstPersonalSkillActivity;
        this.spinnerService.hide();

    });

};


SaveGradedScoreCard  () {
    
    this.examService.SaveGradedScoreCard(JSON.stringify(this.GradedScoreCardModel), JSON.stringify(this.GradedScoreCardList)).subscribe( (response)=> {
       
        this.globalHelper.CheckActionStatus(response);
        this.SearchGradedScoreCard();
    });
}

SubmitGradedScoreCard  () {
    var r = confirm("are you sure you want to submit you will not able to edit");
    if (r == false) {
        return false
    }
    
    this.GradedScoreCardModel.IsSubmitted = true;
    this.examService.SaveGradedScoreCard(JSON.stringify(this.GradedScoreCardModel), JSON.stringify(this.GradedScoreCardList)).subscribe( (response)=> {
        

        this.globalHelper.CheckActionStatus(response);
        this.SearchGradedScoreCard();

    });

}



GetDate  (str) {
    var dateString = str.substr(6);
    var currentTime = new Date(parseInt(dateString));
    var month = currentTime.getMonth() + 1;
    var day = currentTime.getDate();
    var year = currentTime.getFullYear();
    var date = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
    return date;
};



ClassSectionList:any;
GetClassSection  () {
    this.lookupService.GetLookupsList('ClassSectionSkillActivity', '').subscribe( (data)=> {
        this.ClassSectionList = data.LookupItems;

    });

};



SetID  () {
    this.GradedScoreCardList = [];
    this.GradedScoreCardModel.ClassID = 0;
    this.GradedScoreCardModel.SectionID = 0;

    if (this.GradedScoreCardModel.ClassSectionID != "" ) {
        var strClassSectionID = this.GradedScoreCardModel.ClassSectionID.split('-');
        this.GradedScoreCardModel.ClassID = parseInt(strClassSectionID[0]);
        this.GradedScoreCardModel.SectionID = parseInt(strClassSectionID[1]);
        this.GetExam();
    }
   
    this.GradedScoreCardModel.ExamMapID = 0;
    this.GradedScoreCardModel.PersonalSkillID = 0;
    this.GetExamClassAchivementScale();
}
ExamAchivementScaleList:any;
GetExamClassAchivementScale  () {
    this.spinnerService.show();
    var item = {
        ItemId: this.GradedScoreCardModel.ClassID,

    }
    this.lookupService.GetLookupsList('ExamClassAchivementScale', JSON.stringify(item)).subscribe( (data)=> {
        this.ExamAchivementScaleList = data.LookupItems;
        this.spinnerService.hide();
    });

};

ExamList:any;
GetExam  () {
    var item = {
        ItemId: this.GradedScoreCardModel.ClassID,

    }
    this.lookupService.GetLookupsList('Exam', JSON.stringify(item)).subscribe( (data)=> {
        this.ExamList = data.LookupItems;
        this.GetPerssonalSkill();
    });
};
PerssonalSkillList:any;
GetPerssonalSkill  () {
    this.spinnerService.show();
    this.GradedScoreCardList = [];
    this.GradedScoreCardModel.PersonalSkillID = 0;
    var item = {
        ItemId: this.GradedScoreCardModel.ClassID,

    }
    this.lookupService.GetLookupsList('PerssonalSkill', JSON.stringify(item)).subscribe( (data)=> {
        this.PerssonalSkillList = data.LookupItems;
        this.spinnerService.hide();
    });
};


  ngOnInit() {
    this.GetClassSection(); 
  }

}
